
<div class="row mb-4" *ngIf="tenant">
  <app-tenant-html-form
    [tenantModel]="editTenantModel"
    [tenant]="tenant"
    (submitedValue)="update($event)"
  ></app-tenant-html-form>
</div>
